<script>
  export let label = "Loading";
</script>

<div class="loading_indicator" role="status" aria-live="polite">
  <div class="spinner"></div>
  <span>{label}</span>
</div>

<style>
  .loading_indicator {
    display: inline-flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.75rem 1rem;
    border-radius: 0.5rem;
    background-color: var(--pax-white);
    color: var(--pax-black);
    box-shadow: 0 0.75rem 1.5rem rgba(0, 0, 0, 0.12);
    font-weight: 600;
  }

  .spinner {
    width: 1.25rem;
    height: 1.25rem;
    border: 2px solid #d9d9d9;
    border-top-color: var(--pax-black);
    border-radius: 50%;
    animation: spin 700ms linear infinite;
  }

  span {
    line-height: 1;
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
</style>
